function getPageLinkForIndex(index, offset, setOffset) {
    return (
      <h2
        key={index}
        className={`small-medium-text fw-600 d-flex align-items-center justify-content-center cursor-pointer p-0 mb-0 ${offset === index ? 'page-link-selected' : 'page-link-default'}`}
        onClick={() => setOffset(index)}
      >
        {index + 1}
      </h2>
    );
  }
  
  const generatePaginationFooter = (availableDataCount, limit, offset, setOffset) => {
    const totalCount = Math.ceil(availableDataCount / limit);
    if (totalCount > 1) {
      return (
        <div className="d-flex justify-content-center align-items-center gap-3 mt-3 Paginationcountrespo">
          <div className="d-flex align-items-center justify-content-center footercountrespo" style={{ gap: "12px" }}>
            <a
              className="small-medium-text fw-500 secondary cursor-pointer customnavbtn"
              style={{ opacity: offset === 0 ? 0.2 : 1 }}
              onClick={() => {
                if (offset > 0) setOffset(offset - 1);
              }}
            >
              Prev
            </a>
            {generatePaginationLinks(availableDataCount, limit, offset, setOffset)}
            <a
              className="small-medium-text fw-500 secondary cursor-pointer customnavbtn"
              style={{ opacity: offset === totalCount - 1 ? 0.2 : 1 }}
              onClick={() => {
                if (offset < Math.ceil(availableDataCount / limit) - 1) setOffset(offset + 1);
              }}
            >
              Next
            </a>
          </div>
        </div>
      );
    }
  };
  
  const generatePaginationLinks = (availableDataCount, limit, offset, setOffset) => {
    const totalCount = Math.ceil(availableDataCount / limit);
    if (totalCount <= 7) {
      return Array.from({ length: totalCount }, (_, index) => getPageLinkForIndex(index, offset, setOffset));
    } else {
      const pageLinks = [];
      pageLinks.push(getPageLinkForIndex(0, offset, setOffset));
      if (offset > 3) {
        pageLinks.push(<h2 key="start-ellipsis" className="small-medium-text fw-600 d-flex align-items-center justify-content-center p-0 mb-0">...</h2>);
      }
      const startPage = Math.max(1, offset - 1);
      const endPage = Math.min(totalCount - 2, offset + 1);
      for (let i = startPage; i <= endPage; i++) {
        pageLinks.push(getPageLinkForIndex(i, offset, setOffset));
      }
      if (offset < totalCount - 4) {
        pageLinks.push(<h2 key="end-ellipsis" className="small-medium-text fw-600 d-flex align-items-center justify-content-center p-0 mb-0">...</h2>);
      }
      pageLinks.push(getPageLinkForIndex(totalCount - 1, offset, setOffset));
      return pageLinks;
    }
  };
  
  export default generatePaginationFooter;
  